import { KeyRound, X } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import SshSchluesselPanel from './SshSchluesselPanel';
import MeineAdressFreigabe from './MeineAdressFreigabe';

/**
 * Der eigene SSH-Zugang — Selbstbedienung.
 *
 * ══ WARUM NICHT NUR IN DER BENUTZERVERWALTUNG ══════════════════════════════
 *
 * Dort liegt dasselbe Panel, aber die Seite ist nur fuer Admins. Wer einen
 * Schluessel braucht, ist nicht zwangslaeufig einer — und muesste dann jemanden
 * bitten. Genau dieser Umweg sollte wegfallen.
 *
 * ══ WAS HIER FEHLT, FEHLT ABSICHTLICH ══════════════════════════════════════
 *
 * Server ausschliessen und FREMDE Adressen freigeben sind Rechtevergaben und
 * bleiben bei den Admins. Was den eigenen Zugang betrifft, steht hier: einen
 * Schluessel erzeugen, ihn verteilen, und die Adresse freigeben, von der man
 * gerade kommt.
 */
export default function MeinSshModal({ onClose }: { onClose: () => void }) {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/40 p-4">
      <div className="mt-10 flex max-h-[85vh] w-full max-w-xl flex-col overflow-hidden rounded-xl bg-surface shadow-xl">
        <div className="flex shrink-0 items-center justify-between border-b border-slate-200 px-5 py-3">
          <div>
            <h2 className="flex items-center gap-1.5 text-base font-semibold text-slate-900">
              <KeyRound size={16} /> Mein SSH-Zugang
            </h2>
            <p className="mt-0.5 text-xs text-slate-500">
              Schluessel erzeugen, verteilen — und die Adresse freigeben, von der du kommst.
            </p>
          </div>
          <button
            onClick={onClose}
            className="rounded p-1 text-slate-400 hover:bg-slate-100"
            aria-label="Schliessen"
          >
            <X size={16} />
          </button>
        </div>
        <div className="overflow-y-auto px-5 py-4">
          {/* istAdmin=false: Ausschluesse und Freigaben bleiben den Admins in
              der Benutzerverwaltung vorbehalten. */}
          <div className="space-y-3">
            <SshSchluesselPanel userId={user.id} istAdmin={false} />
            {/* Nur die eigene, aktuelle Adresse -- kein Eingabefeld. */}
            <MeineAdressFreigabe />
          </div>
        </div>
      </div>
    </div>
  );
}
